export class ProductSwatches extends window.BAO.CustomElement() {
  constructor () {
    super()
    const { sectionRenderer } = window.BAO

    sectionRenderer
      .fetchSingle('product-swatches', `${this.getAttribute('data-url')}`)
      .then(html => {
        this.innerHtml = this.innerHTML = sectionRenderer.getOuterHtml(html, {
          id: 'shopify-section-product-swatches',
          selector: '.prd-Swatches',
        })
      })
  }
}

if (!customElements.get('product-swatches')) {
  customElements.define('product-swatches', ProductSwatches)
}
